<template>
  <section
    v-if="mainContent"
    class="max-w-screen-3xl mx-auto pt-32 pb-16 px-4 lg:flex lg:items-center"
  >
    <div class="text-left max-w-xl mx-auto">
      <h2>{{ mainContent.title }}</h2>
      <div class="mb-12 lg:mb-0 lg:mr-8">
        <p>
          {{ mainContent.text }}
        </p>
      </div>

      <div
        class="inline-block text-md text-secondary-500 px-2 py-1 ml-2 border border-secondary-500 rounded mb-4 lg:mt-16"
        :class="{ availableTag: mainContent.available }"
      >
        Disponible<span v-if="!mainContent.available">
          el {{ mainContent.date }} a las {{ mainContent.time }}
        </span>
      </div>
    </div>

    <div class="w-full max-w-3xl mx-auto lg:max-w-6xl lg:pl-8">
      <div v-if="mainContent.available">
        <VideoHome v-if="video" />

        <div v-else class="relative flex justify-center">
          <img :src="mainContent.image_url" :alt="mainContent.title" />

          <div class="bg-img">
            <div class="px-4">
              <p class="text-white mb-8 text-shadow">
                Para ver este contenido es necesario que hayas accedido a tu
                cuenta
              </p>
              <BaseButton :to="{ name: 'Login' }">
                Accede
              </BaseButton>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <img :src="mainContent.image_url" :alt="mainContent.title" />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import VideoHome from '@/components/VideoHome'

export default {
  components: { VideoHome },

  computed: {
    ...mapState('home', ['mainContent']),
    ...mapState('videos', ['video']),

    // image() {
    //   return `${process.env.VUE_APP_MEDIA_URL}${this.mainContent.image}`
    // },
  },
}
</script>

<style scoped>
.availableTag {
  @apply text-white bg-green-500 border-green-500;
}

.bg-img {
  @apply absolute inset-0 flex justify-center items-center;
  background: rgba(0, 0, 0, 0.6);
}

.text-shadow {
  text-shadow: 1px 1px 1px black;
}
</style>
